'use strict';
import React, { Component } from 'react';
import TableRowCheckBox from './TableRowCheckBox.jsx';
import Eliminacion from './Eliminacion.jsx';

class TableRow extends Component {

    constructor(props) {
        super(props);

        this.state = {
            data: props.data
        };
    }

    componentWillReceiveProps(nextProps) {
        this.state.data = nextProps.data;
    }

    changeStateCheckBox() {
        let _checked = !this.state.checked;
        this.setState({ checked: _checked });
    }
    
    render() {
        let DeleteLabel;
        if (this.props.deletedProducts.find(x => x === this.props.ID) !== undefined) {
            DeleteLabel = <Eliminacion />;
        } else {
            DeleteLabel = null;
        }
        return (

            <tr>
                <td>
                    <TableRowCheckBox ID={this.props.ID} isChecked={this.props.isChecked}
                        nombre={this.props.nombre} isCurrentUser={this.props.currentUser}
                        onCheck={this.changeStateCheckBox}
                        clickCheckbox={this.props.clickCheckbox}
                        routeToEditarProducto={this.props.routeToEditarProducto} />
                </td>
                <td>
                    <label>{this.props.administradora}</label>
                </td>
                <td>
                    <label>{this.props.tipoCuenta}</label>
                </td>
                <td>
                    {DeleteLabel}
                </td>
            </tr>
        );
    }
}

export default TableRow